import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthHttpService } from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { defaultAppLocaleLanguage } from '../shared/constants/locales.constant';
import { LoggerService } from '../shared/services/logger/logger.service';
import { Account } from './account.model';
import { User } from './user.model';
import { map, take } from 'rxjs/operators';

@Injectable()
export class AccountDataService {
  private _accountServicesUrl = '/as';

  constructor(
    private _loggerService: LoggerService,
    private _authHttpService: AuthHttpService
  ) {}

  getAccount(): Observable<Account> {
    this._loggerService.log('get account from network');

    const url = [this._accountServicesUrl, 'account'].join('/');

    return this._authHttpService.get(url).pipe(
      map(({ body, ..._ }: IResponseInfo) => new Account(body['account'])),
      take(1)
    );
  }

  getUser(): Observable<User> {
    this._loggerService.log('get user from network');

    const url = [this._accountServicesUrl, 'user'].join('/');

    return this._authHttpService.get(url).pipe(
      map(({ body, ..._ }: IResponseInfo) => new User(body.user)),
      take(1)
    );
  }

  changeEmail(
    newEmail: string,
    emailLanguage: string = defaultAppLocaleLanguage.locale
  ): Observable<boolean> {
    this._loggerService.log('setting user email on network');

    const url = [this._accountServicesUrl, 'user', 'change_email'].join('/');
    const body = {
      email: newEmail,
      language: emailLanguage,
    };

    return this._authHttpService.post(url, body).pipe(
      map(() => true),
      take(1)
    );
  }
}
